// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.garageImgTitle {
  font-size: 20px;
  font-weight: 600;
  margin-left: 30px; }

.garageImages {
  padding: 10px;
  border: 1px solid #979797;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 30px;
  border-radius: 5px;
  background-color: #eeeded; }
  .garageImages img {
    border-radius: 5px;
    margin: 5px; }
  .garageImages .ant-image-mask {
    border-radius: 5px; }

.testimonialContainer {
  display: flex;
  flex-direction: column;
  justify-content: space-between; }
  .testimonialContainer .testimonialTitle {
    font-size: 20px;
    font-weight: 600;
    margin-left: 30px; }
  .testimonialContainer .testimonialCards {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap; }
  .testimonialContainer .testimonialCommentCard {
    max-width: 280px;
    width: 100%;
    border: 1px solid #979797;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    margin: 30px;
    padding: 20px;
    background-color: #eeeded; }
    .testimonialContainer .testimonialCommentCard .testimonialName {
      font-size: 16px;
      font-weight: 600;
      padding-top: 15px; }
    .testimonialContainer .testimonialCommentCard img {
      border-radius: 50%;
      height: 80px;
      width: 80px; }

.socialContainer .socialTitle {
  font-size: 20px;
  font-weight: 600;
  margin-left: 30px; }

.socialContainer .socialCards {
  display: flex; }

.socialContainer .socialLink {
  margin: 30px;
  width: 280px;
  height: 40px;
  border: 1px solid #979797;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #eeeded;
  border-radius: 5px; }
  .socialContainer .socialLink .socialIconContainer {
    padding: 10px; }
`, "",{"version":3,"sources":["webpack://./src/components/GarageMarketing/style.scss"],"names":[],"mappings":"AAAA;EACI,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAA;;AAGrB;EACI,aAAa;EACb,yBAAoC;EACpC,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,yBAAoC,EAAA;EARxC;IAWQ,kBAAkB;IAClB,WAAW,EAAA;EAZnB;IAgBQ,kBAAkB,EAAA;;AAI1B;EACI,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAA;EAHlC;IAMQ,eAAe;IACf,gBAAgB;IAChB,iBAAiB,EAAA;EARzB;IAYQ,aAAa;IACb,6BAA6B;IAC7B,eAAe,EAAA;EAdvB;IAkBQ,gBAAgB;IAChB,WAAW;IACX,yBAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,yBAAoC,EAAA;IA5B5C;MA+BY,eAAe;MACf,gBAAgB;MAChB,iBAAiB,EAAA;IAjC7B;MAqCY,kBAAkB;MAClB,YAAY;MACZ,WAAW,EAAA;;AAKvB;EAEQ,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAA;;AAJzB;EAQQ,aAAa,EAAA;;AARrB;EAYQ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yBAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAoC;EACpC,kBAAkB,EAAA;EApB1B;IAuBY,aAAa,EAAA","sourcesContent":[".garageImgTitle {\n    font-size: 20px;\n    font-weight: 600;\n    margin-left: 30px;\n}\n\n.garageImages {\n    padding: 10px;\n    border: 1px solid rgb(151, 151, 151);\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    margin: 30px;\n    border-radius: 5px;\n    background-color: rgb(238, 237, 237);\n\n    img {\n        border-radius: 5px;\n        margin: 5px;\n    }\n\n    .ant-image-mask {\n        border-radius: 5px;\n    }\n}\n\n.testimonialContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    .testimonialTitle {\n        font-size: 20px;\n        font-weight: 600;\n        margin-left: 30px;\n    }\n\n    .testimonialCards {\n        display: flex;\n        justify-content: space-around;\n        flex-wrap: wrap;\n    }\n\n    .testimonialCommentCard {\n        max-width: 280px;\n        width: 100%;\n        border: 1px solid rgb(151, 151, 151);\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        border-radius: 5px;\n        margin: 30px;\n        padding: 20px;\n        background-color: rgb(238, 237, 237);\n\n        .testimonialName {\n            font-size: 16px;\n            font-weight: 600;\n            padding-top: 15px;\n        }\n\n        img {\n            border-radius: 50%;\n            height: 80px;\n            width: 80px;\n        }\n    }\n}\n\n.socialContainer {\n    .socialTitle {\n        font-size: 20px;\n        font-weight: 600;\n        margin-left: 30px;\n    }\n\n    .socialCards {\n        display: flex;\n    }\n\n    .socialLink {\n        margin: 30px;\n        width: 280px;\n        height: 40px;\n        border: 1px solid rgb(151, 151, 151);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-color: rgb(238, 237, 237);\n        border-radius: 5px;\n\n        .socialIconContainer {\n            padding: 10px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
